import React, {useMemo} from "react";
import Page from "../../common/page/Page.js";
import useTranslationAdmin from "../useTranslationAdmin.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import WithRedirectionUserIsAuthorized from "../../authentication-ui/WithRedirectionUserIsAuthorized.js";
import ApplicationListBlock from "./ApplicationListBlock.js";
import {useLocation} from "react-router-dom";
import queryString from "query-string";


export default function ApplicationListPage(/*props*/) {
  const { t, loading: tLoading } = useTranslationAdmin();
  useShowLoader(tLoading, "ApplicationListPage");
  const location = useLocation()

  const filter = useMemo(() => queryString.parse(location.search), [location.search]);

  return (
    <WithRedirectionUserIsAuthorized
      yes={() => (
        <Page className="ApplicationListPage">
          <Page.Title
            text={t("admin:admin_application_list_title")}
            loading={tLoading}
          />
          <Page.Content>
            <ApplicationListBlock filter={filter}/>
          </Page.Content>
        </Page>
      )}
    />
  );
}
